import back from '../../../styles/assets/back_arrow.svg';
import styled from 'styled-components';
import React, { useEffect, useState } from "react";

const Title = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: #FFFFFF;
`;

/* A functional component that takes in a prop called message and returns a div with a span and an
image. */
const CopySuccess = (props: any) => {
  return (
    <div style={{flexDirection:'row',  display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
      <Title>{props.message}</Title>
      <img src={back} alt='back arrow' className='hover'/>
    </div>
  );
}

export default CopySuccess;